import { render, staticRenderFns } from "./ProjectInvitesComponent.vue?vue&type=template&id=5b94495e&scoped=true&"
import script from "./ProjectInvitesComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectInvitesComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInvitesComponent.vue?vue&type=style&index=0&id=5b94495e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b94495e",
  null
  
)

export default component.exports